<tvui-dialog [(visible)]="showPopup" [closable]="false">
	<p class="u-title-sub u-m-bottom--xxs">Sessie gaat verlopen</p>
	<p class="u-m-bottom--sm">Je bent te lang inactief waardoor jouw sessie gaat verlopen. Druk op de knop "Aangemeld blijven" om deze sessie te verlengen.</p>

	<div class="flex-row flex-gap--sm flex-row--end">
		<button (click)="stopSession()" class="c-btn c-btn--secundary">Uitloggen</button>
		<button (click)="keepSession()" class="c-btn c-btn--blue">Aangemeld blijven</button>
	</div>
</tvui-dialog>
